import React, { useState } from 'react'
import { Typography } from 'antd'
import { ButtonTitled, Empty } from 'src/components/Ant'
import { Request } from 'src/types'
import { ModalRequestSummaryObservation } from './modal-request-summary-observation'
import * as Css from './styles'

interface Props
  extends Readonly<{
    request: Request
    enableEditObservation: boolean
    saveRequest?: (request: Request) => void
  }> {}

function getExtraButtons(
  enable: boolean,
  hasValue: string,
  handleVisible: () => void,
  setDelete: () => void
): JSX.Element[] {
  if (!enable) {
    return []
  }
  if (hasValue) {
    return [
      <ButtonTitled
        icon="edit"
        key="change"
        onClick={handleVisible}
        size="default"
        style={{ marginLeft: 8 }}
        tooltip="web.assignment.billing.form.observation.title"
      />,
      <ButtonTitled
        icon="delete"
        key="delete"
        onClick={setDelete}
        size="default"
        style={{ marginLeft: 8 }}
        tooltip="common.actions.remove"
      />
    ]
  }
  return [
    <ButtonTitled
      icon="plus"
      key="add"
      onClick={handleVisible}
      size="default"
      style={{ marginLeft: 8 }}
      tooltip="web.assignment.billing.form.observation.placeholder"
    />
  ]
}

function handleObservation(obs: string) {
  if (!obs) {
    return ''
  }

  return obs.length <= 300 ? obs : `${obs.substring(0, 297)}...`
}

export default function RequestSummaryObservation({
  enableEditObservation = false,
  request,
  saveRequest
}: Props) {
  const [visible, setVisible] = useState(false)
  const observation = handleObservation(request.obs)

  function handleDelete() {
    saveRequest?.({ ...request, obs: '' })
  }

  const extraButtons = getExtraButtons(
    enableEditObservation,
    request.obs,
    () => setVisible(true),
    handleDelete
  )

  return (
    <>
      <Css.Card
        data-test-id="summary-justification-history"
        extra={extraButtons}
        title="web.assignment.billing.form.observation.title"
      >
        {observation.length > 0 ? (
          <Typography.Text>{observation}</Typography.Text>
        ) : (
          <Css.Empty>
            <Empty onlyText />
          </Css.Empty>
        )}
      </Css.Card>
      <ModalRequestSummaryObservation
        request={request}
        saveRequest={saveRequest}
        setVisible={setVisible}
        visible={visible}
      />
    </>
  )
}
